import Image from "../img/img2.png";
import Imagemobile from "../img/img2-mobile.png";
// Imagens SVG dos serviços (iguais ao Service.js)
import ImgConjugal from "../img/team/conjugal.svg";
import ImgFilhos from "../img/team/filhos.svg";
import ImgEmpresarial from "../img/team/empresarial.svg";
import ImgIdoso from "../img/team/cuidador.svg";
import Home from "../img/home.png";
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Utilidade from "../context/Unidades";
import { useHistory, useParams } from "react-router";
import handleMaskTel from "../context/HandleMask";
import Medalha from "../img/app/medalha.webp";
import detetive1 from "../img/team/detetiva-01.svg";
import BrazilMap from "../img/brazil-map.svg";

// CSS para animação dos cards e efeito hover
const customStyles = `
  @keyframes logoSunrise {
    0% { opacity: 0; transform: translateY(20px); filter: brightness(0.8); }
    100% { opacity: 1; transform: translateY(0); filter: brightness(1); }
  }
  .logo-animated {
    animation: logoSunrise 2s ease-out forwards;
  }
  @keyframes zoomInText {
    0% { opacity: 0; transform: scale(0.5); }
    100% { opacity: 1; transform: scale(1); }
  }
  @keyframes zoomInCentered {
    0% { opacity: 0; transform: translate(-50%, -50%) scale(0.5); }
    100% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
  }
  .zoom-in-text {
    display: inline-block;
    animation: zoomInText 1.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
    opacity: 0;
  }
  .zoom-in-centered {
    animation: zoomInCentered 1.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
    opacity: 0;
  }
  @keyframes cardFloat {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-5px); box-shadow: 0 10px 20px rgba(0,0,0,0.1); }
    100% { transform: translateY(0px); }
  }
  .welcome-card:hover {
    animation: none;
    transform: translateY(-8px) scale(1.03);
    box-shadow: 0 15px 30px rgba(155,0,8,0.2);
    border-color: #9B0008;
    transition: all 0.3s ease;
  }
  .welcome-card-anim {
    animation: cardFloat 4s infinite ease-in-out !important;
    opacity: 1 !important;
  }
  .delay-1 { animation-delay: 0s !important; }
  .delay-2 { animation-delay: 0.5s !important; }
  .delay-3 { animation-delay: 1s !important; }
  .delay-4 { animation-delay: 1.5s !important; }
  .container-private {
    margin-bottom: 0 !important;
  }
  .atendimento-mobile-wrapper {
    display: none;
  }
  @media (max-width: 768px) {
    .atendimento-desktop {
      display: none;
    }
    @keyframes holofote {
      0% {
        filter: drop-shadow(0 0 0 rgba(155, 0, 8, 0.7));
      }
      70% {
        filter: drop-shadow(0 0 15px rgba(155, 0, 8, 0.7));
      }
      100% {
        filter: drop-shadow(0 0 0 rgba(155, 0, 8, 0));
      }
    }
    .atendimento-mobile-wrapper {
      position: absolute;
      left: 10px;
      top: 65%;
      transform: translateY(-50%);
      z-index: 10;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .atendimento-mobile-box {
      display: block;
      font-size: 1rem;
      text-align: center;
      width: 80px;
      height: 80px;
      line-height: 1.3;
      position: relative;
      animation: holofote 1.5s infinite;
      background-color: transparent;
      padding: 0;
    }
    .medalhaWelcome {
      position: absolute !important;
      left: -4px !important;
      right: auto !important;
      top: 45% !important;
      transform: translateY(-50%) !important;
      width: 150px !important;
      z-index: 20 !important;
    }
    .welcome-subtitle {
      margin-top: 15px !important;
      margin-bottom: -15px !important;
      position: relative;
      z-index: 5;
      width: 50% !important;
    }
    .welcome-img-mobile {
      margin-top: -170px !important;
      position: relative;
      z-index: 1;
    }
    .container-private {
      align-items: flex-start !important;
      padding-top: 20px !important;
    }
    .welcome-content-mobile {
      margin-bottom: 0 !important;
      justify-content: flex-start !important;
    }
    .cards-wrapper {
      margin-top: 20px;
    }
    .title-detetive {
      font-size: 1.2rem !important;
      font-weight: 900 !important;
      width: fit-content !important;
      padding: 8px 20px !important;
      text-align: left;
      align-self: flex-start !important;
      margin-left: 1px !important;
      margin-top: 15px !important;
    }
  }
`;

export default function Welcome() {
  // Garante que params nunca é undefined
  const history = useHistory();
  const { uf } = useParams();
  const location = useLocation();

  const [brand, setBrand] = useState({});

  useEffect(() => {
    setBrand(Utilidade.renderRegiao(uf));
  }, []);

  if (uf === undefined) {
    history.push("/#ge");
    window.location.reload();
  }

  return (
    <>
      <style>{customStyles}</style>
      <div
        className="container-private"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: "40px",
          paddingBottom: "10px",
          overflowX: "hidden",
        }}
      >
        <div
          className="row m-0"
          style={{ width: "100%", minHeight: "100%", background: "#fff" }}
        >
          {/* Coluna Esquerda - Imagem ocupa toda a coluna */}
          <div
            className="col-xl-6 col-lg-6 col-md-6 d-flex p-0 welcome-hide-mobile"
            style={{
              minHeight: "100vh",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={Image}
              alt="Ilustração"
              style={{ maxHeight: "90vh", width: "100%", objectFit: "contain" }}
            />
          </div>
          {/* Coluna Direita */}
          <div className="col-xl-6 col-lg-6 col-md-12 d-flex flex-column justify-content-center align-items-center welcome-content-mobile">
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", alignSelf: "center", transform: "translateX(3.5vw)" }}>
              <Link
                className="navbar-brand p-0 "
                to={`${process.env.PUBLIC_URL + "/" + uf}`}
              >
                <img
                  src={brand.logo}
                  alt="logo"
                  className="logo-main logo-animated"
                  style={{
                    marginBottom: 10,
                    marginTop: 10,
                    width: 250,
                    height: 80,
                  }}
                />
              </Link>
              <h1
                className="title-detetive"
                style={{
                  marginBottom: "15px",
                  backgroundColor: "#9B0008",
                  color: "#fff",
                  padding: "10px 25px",
                  borderRadius: "20px",
                  display: "inline-block",
                  boxShadow: "0 4px 15px rgba(155, 0, 8, 0.4)",
                  fontSize: "2.2rem"
                }}
              >
                Detetive Particular
              </h1>
            </div>
            <p className="welcome-subtitle" style={{ fontSize: "1.1rem", fontWeight: "500", color: "#9B0008", margin: "0 0 40px 0", maxWidth: "400px", lineHeight: "1.2", textAlign: "center" }}>
              <span className="zoom-in-text">Discrição em cada passo, Sigilo em cada detalhe.</span>
              {window.location.href.includes('#ge') && (
                <span className="atendimento-desktop zoom-in-text" style={{ animationDelay: "0.5s" }}> Atendimento em <strong>todo o Brasil</strong>.</span>
              )}
            </p>

            {/* <p>Explore nossos serviços: </p> */}

            {uf == "sp" ? (
              <img src={Medalha} alt="img" className="medalha medalhaWelcome" />
            ) : null}

            <div className="mobile-image-container" style={{ position: "relative", width: "100%", display: "flex", justifyContent: "center" }}>
              <img
                src={Imagemobile}
                alt="Ilustração"
                className="welcome-img-mobile"
                style={{
                  display: "none",
                  width: "100%",
                  maxWidth: 240,
                  height: 200,
                  objectFit: "cover",
                }}
              />
              {window.location.href.includes('#ge') && (
                <div className="atendimento-mobile-wrapper">
                  <div className="zoom-in-text" style={{ color: "#9B0008", fontSize: "1rem", fontWeight: "bold", textAlign: "center", lineHeight: "1", animationDelay: "0.5s" }}>
                    Atendimento<br />
                    em <strong>todo o</strong>
                  </div>

                  <div className="atendimento-mobile-box">
                    <div className="zoom-in-centered" style={{ color: "#9B0008", position: "absolute", top: "35%", left: "50%", transform: "translate(-50%, -50%)", width: "100%", zIndex: 1, fontWeight: "bold", fontSize: "1.1rem", animationDelay: "1.0s" }}>
                      <strong>Brasil</strong>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "#9B0008",
                        WebkitMaskImage: `url(${BrazilMap})`,
                        WebkitMaskSize: "90%",
                        WebkitMaskPosition: "center",
                        WebkitMaskRepeat: "no-repeat",
                        maskImage: `url(${BrazilMap})`,
                        maskSize: "90%",
                        maskPosition: "center",
                        maskRepeat: "no-repeat",
                        zIndex: 2,
                      }}
                    >
                      <div className="zoom-in-centered" style={{ color: "#fff", position: "absolute", top: "35%", left: "50%", transform: "translate(-50%, -50%)", width: "100%", fontWeight: "bold", fontSize: "1.1rem", animationDelay: "1.0s" }}>
                        <strong>Brasil</strong>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="cards-wrapper">
              <div className="welcome-cards-grid">
                <Link
                  to={`${process.env.PUBLIC_URL}/${uf}/home`}
                  className="welcome-card welcome-card-anim delay-1"
                  tabIndex={0}
                  style={{ textDecoration: "none" }}
                >
                  <img src={Home} alt="Home" />
                  <div className="welcome-card-content">
                    <h4>Home</h4>
                  </div>
                </Link>

                <Link
                  to={`${process.env.PUBLIC_URL}/${uf}/investigacao_conjugal`}
                  className="welcome-card welcome-card-anim delay-1"
                  tabIndex={0}
                  style={{ textDecoration: "none" }}
                >
                  <img src={ImgConjugal} alt="Conjugal" />
                  <div className="welcome-card-content">
                    <h4>Investigação Conjugal</h4>
                  </div>
                </Link>

                <Link
                  to={`${process.env.PUBLIC_URL}/${uf}/investigacao_filhos`}
                  className="welcome-card welcome-card-anim delay-2"
                  tabIndex={0}
                  style={{ textDecoration: "none" }}
                >
                  <img src={ImgFilhos} alt="Filhos" />
                  <div className="welcome-card-content">
                    <h4>Investigação de Filhos</h4>
                  </div>
                </Link>

                <Link
                  to={`${process.env.PUBLIC_URL}/${uf}/investigacao_empresarial`}
                  className="welcome-card welcome-card-anim delay-3"
                  tabIndex={0}
                  style={{ textDecoration: "none" }}
                >
                  <img src={ImgEmpresarial} alt="Empresarial" />
                  <div className="welcome-card-content">
                    <h4>Investigação Empresarial</h4>
                  </div>
                </Link>

                {/* Card: Encontrar Pessoas */}
                <Link
                  to={`${process.env.PUBLIC_URL}/${uf}/localizacao_pessoas`}
                  className="welcome-card welcome-card-anim delay-4"
                  tabIndex={0}
                  style={{ textDecoration: "none" }}
                >
                  <img
                    src={require("../img/team/localizacao.svg").default}
                    alt="Encontrar Pessoas"
                  />
                  <div className="welcome-card-content">
                    <h4>Encontrar Pessoas</h4>
                  </div>
                </Link>
                <Link
                  to={`${process.env.PUBLIC_URL}/${uf}/Defensiva`}
                  className="welcome-card welcome-card-anim delay-3"
                  tabIndex={0}
                  style={{ textDecoration: "none" }}
                >
                  <img src={detetive1} alt="Defensiva" />
                  <div className="welcome-card-content">
                    <h4>Investigação Defensiva</h4>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
